import React from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { BUILD_WORKFLOW_STEPS } from './constants';

const ICONS = {
  upload: CloudUploadOutlinedIcon,
  sparkle: AutoAwesomeOutlinedIcon,
  eye: VisibilityOutlinedIcon,
};

const BuildWorkflowBanner = () => (
  <Box
    display='flex'
    alignItems='stretch'
    gap={{ xs: 1.5, md: 2 }}
    flexWrap={{ xs: 'wrap', md: 'nowrap' }}
    mb={3}
    p={2}
    border={1}
    borderColor='divider'
    borderRadius={2}
    bgcolor='#f8fafc'
  >
    {BUILD_WORKFLOW_STEPS.map((step, index) => {
      const Icon = ICONS[step.icon];
      return (
        <React.Fragment key={step.title}>
          <Box display='flex' alignItems='center' gap={1.25} flex={1} minWidth={180}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                bgcolor: '#e3f2fd',
                color: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Icon fontSize='small' />
            </Box>
            <Typography variant='body2' fontWeight={600} sx={{ lineHeight: 1.35 }}>
              {step.title}
            </Typography>
          </Box>
          {index < BUILD_WORKFLOW_STEPS.length - 1 && (
            <Box display={{ xs: 'none', md: 'flex' }} alignItems='center' color='text.disabled'>
              <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
            </Box>
          )}
        </React.Fragment>
      );
    })}
  </Box>
);

export default BuildWorkflowBanner;
